import { IBridgeSelect } from "@sp-crm/core";
import { AdvancedSearchEntityType, useGetEntitiesQuery } from "generated/graphql";
import React from "react";
import { stableQueryOptions } from "util/requests";
import { EntityNestedFieldPicker } from "./entity-nested-field-picker";
import { EntityTypeEditor } from "./entity-type-editor";
import { availableEntityTypes, resolveSelectedEntityType } from "./entity-type-selection";

interface MultiEntityFieldPickerProps {
    initialType?: AdvancedSearchEntityType | null;
    entityTypes: AdvancedSearchEntityType[];
    onSelected: (entityType: AdvancedSearchEntityType, field: IBridgeSelect) => void;
}

export const MultiEntityFieldPicker: React.FC<MultiEntityFieldPickerProps> = props => {
    const { entityTypes, onSelected, initialType } = props;
    const [preferredEntityType, setPreferredEntityType] =
        React.useState<AdvancedSearchEntityType | null>(initialType ?? null);

    const getEntities = useGetEntitiesQuery({}, stableQueryOptions());
    const entities = getEntities?.data?.getEntities ?? [];

    const allowedEntityTypes = availableEntityTypes(entityTypes, entities);
    const selectedEntityType = resolveSelectedEntityType(
        allowedEntityTypes,
        preferredEntityType,
    );

    const handlePlaceholder = React.useCallback(
        (value: IBridgeSelect) => {
            onSelected(selectedEntityType, value);
        },
        [onSelected, selectedEntityType],
    );

    const entityMetadata = entities.find(e => e.name === selectedEntityType);

    if (entityMetadata) {
        return (
            <div>
                <div className="px-4 pt-4">
                    <EntityTypeEditor
                        entities={entities}
                        entityType={selectedEntityType}
                        onChange={setPreferredEntityType}
                        allowedEntityTypes={allowedEntityTypes}
                        textSize="sm"
                        postLabel="Placeholders"
                    />
                </div>
                <EntityNestedFieldPicker
                    value={{}}
                    onChange={handlePlaceholder}
                    entities={entities}
                    entityMetadata={entityMetadata}
                    includeQuestions={false}
                />
            </div>
        );
    }

    return null;
};
